import React from "react";
import ct from "class-types.macro";
import StandardPrice from "../Price";
import Icon from "~/common/Icons/Standard";
import { SelectedProduct } from "~/common/Store/models/ProductListing";

export interface Props {
  qualifiedForMapPrice: boolean;
  selectedProduct: SelectedProduct;
  currentUrl: string;
  handleChatLinkClick: (e: React.SyntheticEvent) => void;
}

const LowestGuaranteedPriceWithChatNowLink = ({
  qualifiedForMapPrice,
  selectedProduct,
  currentUrl,
  handleChatLinkClick,
}: Props) => {
  return (
    <a
      className={ct("block", "p-1")}
      data-item-number={selectedProduct.itemNumber}
      href={`/chat/?referringURL=${encodeURIComponent(currentUrl)}`}
      onClick={handleChatLinkClick}
      target="_blank"
    >
      <StandardPrice
        price={
          !qualifiedForMapPrice
            ? selectedProduct.price.price
            : selectedProduct.price.minimumAdvertisedPriceProperties.price
        }
        unitOfMeasure={selectedProduct.unitOfMeasure}
        textSize="custom"
        className={ct("text-lg", "pt-0", "xxs:text-2xl")}
      />
      <p className={ct("text-xs", "leading-tight", "mb-0")}>
        <span className={ct("font-semibold", "text-red-500")}>
          Lowest Price Guarantee
        </span>
        <span className={ct("block", "text-gray-800")}>
          Chat Now
          <Icon
            name="breadcrumb"
            className={ct("h-3", "align-middle", "w-3")}
          />
        </span>
      </p>
    </a>
  );
};

export default LowestGuaranteedPriceWithChatNowLink;
